var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mit-maps-page mit-page"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"mit-info-card"},[_c('v-card-title',[_vm._v("New Person")]),_c('v-card-subtitle',{staticClass:"caption"},[_vm._v("Start adding a new person to CSAIL")]),_c('v-divider'),_c('v-card-text',[_c('MitActionsNewPersonWizard')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }